import { TextField } from '@material-ui/core';
import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react'
import { Autocomplete } from '@material-ui/lab';
import { fetchConToken } from '../../../helpers/fetch';

const BuscadorModulos = forwardRef(({ label, fieldsDisabled, cod, setCod, idEfectorFacturacion }, ref) => {
  const [loadingCod, setLoadingCod] = useState(false);
  const [optionsCod, setOptionsCod] = useState([]);
  const [parametroCod, setParametroCod] = useState("");

  const onChangeCodHastaHandler = (e) => {
    let typingTimer = null;
    if (e.target.value.length > 0) {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        setParametroCod(e.target.value);
      }, 700);
    } else {
      setOptionsCod([]);
    }
  };

  useImperativeHandle(ref, () => ({
    resetValues: () => {
      setOptionsCod([]);
    }
  }));

  useEffect(() => {
    let active = true;
    setLoadingCod(true);
    (async () => {
      if (parametroCod.length > 0) {
        const response = await fetchConToken(
          `Modulos/PorEfectorFacturacion/${idEfectorFacturacion}?parametroBusqueda=${parametroCod}`
        );
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const options = await response.json();
          if (active && options.length > 0) {
            setOptionsCod(options);
          }
        }
        setLoadingCod(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [parametroCod]);

  return (
    <Autocomplete
      disabled={fieldsDisabled}
      value={cod}
      onChange={(event, newValue) => {
        setCod(newValue);
      }}
      options={optionsCod || []}
      loading={loadingCod}
      loadingText="Buscando..."
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      getOptionLabel={(option) => `${option.codigo} - ${option.descripcion}`}
      renderOption={(option) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span>{`${option.codigo}-${option.descripcion}`}</span>
        </div>
      )}
      freeSolo
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          onChange={onChangeCodHastaHandler}
        />
      )}
    />
  )
}
)

export default BuscadorModulos
